// *******************************************************************************
// Scrolling menu slider
// *******************************************************************************

const scrollingSliderElements = document.querySelectorAll('[data-slider="scrolling-menu-slider"]');
if (scrollingSliderElements.length > 0) {
  const scrollingSliderOptions = {
    slidesPerView: 'auto',
    spaceBetween: 10,
    loop: false,
    autoHeight: false,
    navigation: {
      nextEl: '.swiper-button-prev',
      prevEl: '.swiper-button-next',
    },
    allowTouchMove: true,
    watchOverflow: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        spaceBetween: 28,
      },
      1240: {
        spaceBetween: 40,
      },
    },
  };

  scrollingSliderElements.forEach((el) => {
    const scrollingSliderParent = el.closest('.scrolling-menu');
    const arrowRight = scrollingSliderParent.querySelector('.arrow-right');
    const arrowLeft = scrollingSliderParent.querySelector('.arrow-left');

    scrollingSliderOptions.navigation.nextEl = arrowRight;
    scrollingSliderOptions.navigation.prevEl = arrowLeft;

    // eslint-disable-next-line no-new
    new Swiper(el, scrollingSliderOptions);
  });

  // *******************************************************************************
  // Scroll to Section
  // *******************************************************************************

  attachEvent('.scrolling-menu__item:not(.scrolling-menu__item--tab)', 'click', (ev) => {
    if (ev.target.hash) {
      const topOffset = getOffsetTop(document.querySelector(ev.target.hash));
      const parentElem = ev.target.closest('.scrolling-menu__slider');
      const navItem = parentElem.querySelectorAll('.scrolling-menu__item:not(.scrolling-menu__item--tab)');
      const scrollMenuHeight = document.querySelector('.scrolling-menu').offsetHeight;
      const finalOffset = topOffset - scrollMenuHeight;

      navItem.forEach((el) => {
        el.classList.remove('is-active');
      });

      ev.target.classList.add('is-active');

      scrollToSmoothly(finalOffset, 100);
      ev.preventDefault();
    }
  });

  // *******************************************************************************
  // Add/Remove sticky class
  // *******************************************************************************

  const scrollingMenu = document.querySelector('.scrolling-menu');
  const sticky = getOffsetTop(scrollingMenu);
  const toggleStickyClass = () => {
    document.body.classList.toggle('sticky-scrolling-menu', window.pageYOffset >= sticky);
  };

  window.onscroll = function () {
    toggleStickyClass();
  };
}
